import { useStore } from 'vuex'
import { NAMESPACES, type RootState } from '@/store'
import { DEVICE_GETTERS } from '@/store/devices'

export function useWaitingData() {
  const store = useStore<RootState>()

  function smartBridgeDeviceId(deviceId: string): string {
    return store.getters[
      `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_CONNECTED_SMART_BRIDGE_ID_BY_DEVICE_ID}`
    ](deviceId)
  }

  function isDeviceConnectedToSB(deviceId: string): boolean {
    return !!smartBridgeDeviceId(deviceId)
  }

  function isDeviceConnected(deviceId: string): boolean {
    return store.getters[`${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_IS_CONNECTED_BY_DEVICE_ID}`](
      deviceId
    )
  }

  function lastTelemetryTimestamp(deviceId: string): string | undefined {
    return store.getters[`${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_LAST_CONTACT_BY_DEVICE_ID}`](
      deviceId
    )
  }

  function isTelemetry24HrsActive(deviceId: string): boolean {
    return store.getters[
      `${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_IS_TELEMETRY_24HRS_ACTIVE_BY_DEVICE_ID}`
    ](deviceId)
  }

  function isSmartBridgeConnected(deviceId: string): boolean {
    return store.getters[`${NAMESPACES.DEVICES}/${DEVICE_GETTERS.GET_IS_CONNECTED_BY_DEVICE_ID}`](
      smartBridgeDeviceId(deviceId)
    )
  }

  function isWaitingInitialData(deviceId: string): boolean {
    const isTelemetryActive = !!lastTelemetryTimestamp(deviceId) && isTelemetry24HrsActive(deviceId)
    const isConnected = isDeviceConnectedToSB(deviceId)
      ? isDeviceConnected(deviceId) && isSmartBridgeConnected(deviceId)
      : isDeviceConnected(deviceId)
    return isConnected && !isTelemetryActive
  }

  return {
    isDeviceConnectedToSB,
    isDeviceConnected,
    lastTelemetryTimestamp,
    isTelemetry24HrsActive,
    smartBridgeDeviceId,
    isSmartBridgeConnected,
    isWaitingInitialData
  }
}
